<template lang="html">
  <div>
    <v-col cols="12">
    <div class="subtitle-2 font-weight-bold mb-2">
      {{ `${$tc('title.dados_pessoais', 1)}:` }}
    </div>
    <v-divider class="mb-4"></v-divider>
  </v-col>
    <v-row class="ml-4 mb-3">
      <v-col cols="12" sm="4" md="4" slot="antes">
        <v-text-field
          :class="{ 'hint-laranja': showHint }"
          :label="`${$t('label.email')} *`"
          ref="email"
          v-model="usuario.email"
          required
          :rules="[rules.requiredText, rules.isEmailValid]"
          maxlength="150"
          autocomplete="null"
          clearable
          counter
          :disabled="isSomenteLeituraDadosSensiveis"
          :hint="showHint ? $t('label.mensagem_inserir_email_pessoal') : ''"
          :persistent-hint="showHint"
          @focus="showHint = true"
          @blur="showHint = false">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="6" slot="antes">
        <v-btn
          id="btn_buscar_usario_omni"
          :disabled="somenteLeitura || usuario.ehEdicao() || encontrouOmni"
          @click.native="buscarUsuarioOmni">
          {{ $t('label.buscar') }}
        </v-btn>
        <v-btn
          id="btn_limpar_busca"
          class="ml-3"
          :disabled="somenteLeitura || usuario.ehEdicao()"
          @click.native="limparFormulario">
          {{ $t('label.limpar') }}
        </v-btn>
      </v-col>
      <v-col cols="12" sm="4" md="4" slot="antes">
        <v-text-field
          :label="`${$t('label.nome')} *`"
          v-model="usuario.nome"
          autocomplete="null"
          required
          :rules="[rules.requiredText]"
          maxlength="100"
          counter
          :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4" slot="antes">
        <v-text-field
          :label="$t('label.sobrenome')"
          v-model="usuario.sobrenome"
          autocomplete="null"
          maxlength="150"
          counter
          :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor">
        </v-text-field>
      </v-col>
      <v-col cols="6" sm="2" md="2" slot="antes">
        <v-text-field
          :label="`${$t('label.cargo')} *`"
          v-model="usuario.cargo"
          maxlength="50"
          counter
          required
          :rules="[rules.requiredText]"
          :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor">
        </v-text-field>
      </v-col>
      <v-col cols="6" sm="2" md="2" slot="antes">
        <v-text-field
          :label="`${$t('label.documento')} *`"
          v-model="usuario.documento"
          maxlength="50"
          counter
          required
          :rules="[rules.requiredText]"
          :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4">
        <tenant-usuario-logado-list v-if="tenantsUsuario" :tenants="tenantsUsuario"></tenant-usuario-logado-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TenantUsuarioLogadoList from '../../shared-components/tenant/TenantUsuarioLogadoList';

export default {
  name: 'UsuarioFornecedorDadosPessoaisForm',
  props: {
    somenteLeitura: Boolean,
    default: false,
    usuario: {
      type: Object,
      default: {},
    },
    encontrouOmni: {
      type: Boolean,
      default: false,
    },
    isSomenteLeituraDadosSensiveis: {
      type: Boolean,
      default: false,
    },
    desabilitarCadastroFornecedor: {
      type: Boolean,
      default: false,
    },
    tenantsUsuario: {
      type: Array,
      default: [],
    },
  },
  components: {
    TenantUsuarioLogadoList,
  },
  computed: {
  },
  watch: {
  },
  data() {
    return {
      showHint: false,
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredText: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        isEmailValid: (value) => this.emailReg.test(value) || this.$t('message.campo_obrigatorio_ou_invalido'),
      },
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  methods: {
    buscarUsuarioOmni() {
      if (!this.$refs.email.validate(true)) return;
      this.$emit('BuscarUsuarioOmni');
    },
    limparFormulario() {
      this.$emit('LimparFormulario');
    },
  },
  mounted() {
  },
};
</script>
<style scoped>

.row {
  margin-left: 0;
  margin-right: 0;
}

.hint-laranja .v-messages__message:not(.error--text) {
  color: orange !important;
}

.hint-laranja ::v-deep .v-messages__message:not(.error--text) {
  color: orange !important;
}

</style>
